<template>
  <div class="container-relatorio-filtros">
    <div>
      <div class="primary--text text-selecione">
        <span>Selecione os filtros</span> »
        <label>Relação de cobranças</label>
      </div>
      <PesquisaPacienteModal
          v-if="modalSelecionarPaciente"
          v-model="modalSelecionarPaciente"
          @fecharModalPesquisaPaciente="fecharModalSelecionarPaciente"
          @confirmarPacienteSelecionado="selecionarPaciente"
      />
      <div class="container-relatorio-interno">
        <div v-if="pacienteSelecionado.id" class="container-card-paciente tertiary">
          <div class="container-acessar-ficha">
            <div>
              <span style="font-size: 14px">Nome</span><br/>
              <p class="d-inline-block text-truncate max-text">{{ pacienteSelecionado.nome }}</p>
            </div>
          </div>
          <span style="font-size: 14px">CPF/CNPJ</span>
          <p>{{ pacienteSelecionado.cnpjCpf | formatarCpfCnpj }}</p>
        </div>
        <div class="container-selecionar-paciente">
          <botao-acao hideBorder @click="removerPaciente" class="mr-4" v-if="pacienteSelecionado.id">
            <v-icon>close</v-icon>
            Remover Paciente
          </botao-acao>
          <botao-acao hideBorder @click="abrirModalSelecionarPaciente">
            <v-icon>mdi-magnify</v-icon>
            Selecionar Paciente
          </botao-acao>
        </div>
        <v-row wrap align-center white class="pl-5 pr-5">
          <v-col cols="12" md="12" sm="12" xs="12">
            <v-select
                v-model="filtros.statusCobranca"
                label="Selecionar o status"
                :items="statusItems"
                item-text="nome"
                item-value="valor"
            />
          </v-col>
          <v-col cols="4" md="4" sm="12" xs="12">
            <v-select
                v-model="filtros.tipoPeriodo"
                label="Selecionar tipo período"
                :items="periodoItens"
                item-text="nome"
                item-value="valor"
            />
          </v-col>
          <v-col cols="4" md="4" sm="12" xs="12">
            <date-input
                v-model="filtros.dataInicio"
                label="Data Início"
                name-date="dataInicio"
                placeholderDate="Informe a data de início"
            />
          </v-col>
          <v-col cols="4" md="4" sm="12" xs="12">
            <date-input
                v-model="filtros.dataFim"
                label="Data Fim"
                name-date="dataFim"
                placeholderDate="Informe a data final"
            />
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="row-bottom">
      <v-tooltip top>
        <template v-slot:activator={on}>
          <v-btn
              v-on="on"
              id="botaoDownload"
              class="mr-5"
              icon
              @click="gerarRelatorio(true)">
            <v-icon>mdi-file-download</v-icon>
          </v-btn>
        </template>
        Baixar .PDF
      </v-tooltip>
      <v-btn
          id="botaoGerar"
          color="primary"
          depressed
          @click="gerarRelatorio(false)">
        Gerar relatório
      </v-btn>
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import {actionTypes} from '@/core/constants'
import DateInput from '@/views/components/DateInput.vue'
import PesquisaPacienteModal from '@/views/modais/PesquisaPacienteModal.vue'
import BotaoAcao from '@/views/components/BotaoAcao.vue'

export default {
    name: 'RelatorioCobrancasGeral',
    components: {BotaoAcao, PesquisaPacienteModal, DateInput},
    data() {
        return {
            modalSelecionarPaciente: false,
            pacienteSelecionado: {
                id: null,
                nome: null,
                cnpjCpf: null
            },
            filtros: {
                dataInicio: null,
                dataFim: null,
                tipoPeriodo: 'DATA_CRIACAO',
                statusCobranca: 'TODOS',
            },
            periodoItens: [
                {nome: 'Data criação', valor: 'DATA_CRIACAO'},
                {nome: 'Data pagamento', valor: 'DATA_PAGAMENTO'},
                {nome: 'Data estorno', valor: 'DATA_ESTORNO'},
            ],
            statusItems: [
                {nome: 'Todos os status', valor: 'TODOS'},
                {nome: 'Pagamento pendente', valor: 'PENDENTE'},
                {nome: 'Parcialmente paga', valor: 'PARCIALMENTE_PAGO'},
                {nome: 'Pago', valor: 'PAGO'},
                {nome: 'Cancelada', valor: 'CANCELADA'},
            ]
        }
    },
    mounted() {
        this.setarPacientePreSelecionado()
    },
    methods: {
        setarPacientePreSelecionado() {
            if (this.pacientePreSelecionado) {
                this.pacienteSelecionado = this.pacientePreSelecionado
            }
        },
        abrirModalSelecionarPaciente() {
            this.modalSelecionarPaciente = true
        },
        fecharModalSelecionarPaciente() {
            this.modalSelecionarPaciente = false
        },
        selecionarPaciente(paciente) {
            this.fecharModalSelecionarPaciente()
            this.pacienteSelecionado = paciente
        },
        removerPaciente() {
            this.pacienteSelecionado = {
                id: null,
                nome: null,
                cnpjCpf: null
            }
        },
        async gerarRelatorio(baixar) {

            if (!this.filtros.dataInicio || !this.filtros.dataFim) {
                this.mostrarNotificacaoErro('Informe o período!')
                return
            }

            let filtros = {
                dataInicio: moment(this.filtros.dataInicio).format('YYYY-MM-DD'),
                dataFim: moment(this.filtros.dataFim).format('YYYY-MM-DD'),
                tipoPeriodo: this.filtros.tipoPeriodo,
                statusCobranca: this.filtros.statusCobranca,
                pacienteId: this.pacienteSelecionado.id,
                baixar: baixar
            }
            await this.$store.dispatch(actionTypes.RELATORIOS.GERAR_RELATORIO_COBRANCA, filtros)
        },
    }
}
</script>

<style scoped lang="stylus">

.container-relatorio-filtros
  width 100%
  display flex
  flex-direction column
  justify-content space-between

.row-bottom
  border-top-width 1px
  border-top-style solid
  border-top-color #ccc
  box-sizing border-box
  padding-top 10px
  padding-bottom 10px
  padding-right 20px
  text-align right

.text-selecione
  padding-top 10px
  padding-left 10px
  border-bottom 1px solid #ddd

  span
    font-weight bold

.container-relatorio-interno
  padding 20px

.container-card-paciente
  border-radius 5px
  padding 5px
  margin-bottom 10px

  p
    font-weight bold
    color #5A5A5A

.container-acessar-ficha
  display flex
  justify-content space-between

.container-selecionar-paciente
  text-align right
  margin-bottom 10px

.max-text
  max-width 15vw

</style>